import React, { useMemo } from "react";
import { RouteProps } from "react-router-dom";
import styled from "styled-components";
import { PageTemplateDirectoryAcf } from "../../constants/types/acf";
import { useCurrentRouteData, useAppState, useFreeServiceVisibility } from "../../services/app-state";
import { useSuburbName } from "../../utils";
import { colors } from "../../utils/colors";
import { DirectoryContent } from "../organisms/DirectoryContent";
import { HeroDirectory } from "../organisms/HeroDirectory";
import { OtherSupport } from "../organisms/HomeOtherSupport";
import { NotSureWhereToBegin } from "../organisms/NotSureWhereToBegin";
import { ServicesInRegionListings } from "../organisms/ServicesInRegionListings";
const PageWrapper = styled.div`
    background-color: ${colors.white};
`;
const Spacer = styled.div`
    margin-bottom: 50px;
`;

export const DirectoryTemplate: React.FC<RouteProps> = () => {
    const page = useCurrentRouteData<PageTemplateDirectoryAcf>();
    const [{ servicesInRegion }] = useAppState();
    const suburbName = useSuburbName();
    const [showingFreeService] = useFreeServiceVisibility();

    const digitalServices = useMemo(() => servicesInRegion.filter(function (el) {
        if (showingFreeService) {
            return el.acf.location_toggle == "digital" && el.acf.meta.cost_of_service == 'free'
        }
        return el.acf.location_toggle == "digital"
    }), [showingFreeService, servicesInRegion]);
    
    const regionalServices = useMemo(() => servicesInRegion.filter(function (el) {
        if (showingFreeService) {
            return el.acf.location_toggle == "physical_regions" && el.acf.meta.cost_of_service == 'free'
        }
        return el.acf.location_toggle == "physical_regions"
    }), [showingFreeService, servicesInRegion]);

    return (
        <>
            <HeroDirectory title={page.title.rendered} image={page.acf.meta?.hero_image} />
            <PageWrapper>
                {suburbName ?
                    <>
                        <DirectoryContent />
                        <ServicesInRegionListings displayRegion={true} title="Services available in" pagename="service" description='' items={regionalServices} compact={false} />
                        <ServicesInRegionListings displayRegion={false} title="Phone and online services" pagename="service" description='' items={digitalServices} compact={true} />
                    </> 
                : null
                }
                <Spacer />
                <OtherSupport />
                <NotSureWhereToBegin topColor={colors.brandMid} bottomColor={colors.white} />
            </PageWrapper>
        </>
    );
};
